var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height background"},[_c('NavigationDrawer',{attrs:{"drawer":_vm.drawer},on:{"closeDrawer":_vm.closeDrawer}}),_c('AppBar',{on:{"switchDrawer":_vm.switchDrawer}}),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }